// extracted by mini-css-extract-plugin
export default {"wrapper":"iViyA","container":"oJhnE","label":"YqRu6","checkbox":"nxqBx","errorMessage":"piRYt","error":"fi82O"};